function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { FormattedMessage, FormattedNumber } from "react-intl";
import moment from "moment";
import messages from "./FormatMetric.messages";

class FormatMetric extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "formatInteger", () => {
      let value = this.props.value;

      if (this.context.intl) {
        return React.createElement(FormattedNumber, {
          value: value
        });
      }

      value = new Intl.NumberFormat('de-DE').format(value);
      return value;
    });

    _defineProperty(this, "formatFloat", () => {
      let _this$props = this.props,
          value = _this$props.value,
          decimals = _this$props.decimals;

      if (this.context.intl) {
        return React.createElement(FormattedNumber, {
          value: value,
          minimumFractionDigits: 2,
          maximumFractionDigits: decimals
        });
      }

      value = parseFloat(value).toFixed(decimals);
      value = new Intl.NumberFormat('de-DE').format(value);
      return value;
    });

    _defineProperty(this, "formatPercent", () => {
      let _this$props2 = this.props,
          value = _this$props2.value,
          decimals = _this$props2.decimals;
      value = parseFloat(value).toFixed(decimals) + "%";
      return value;
    });

    _defineProperty(this, "formatTime", () => {
      let value = this.props.value;
      value = moment().startOf('day').add(value, "seconds").format('HH:mm:ss');
      return value;
    });

    _defineProperty(this, "formatDuration", () => {
      let value = this.props.value;
      var sec_num = parseInt(value, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours) {
        return hours + 'h ' + minutes + 'm ' + seconds + 's';
      }

      if (minutes) {
        return minutes + 'm ' + seconds + 's';
      }

      return seconds + 's';
    });

    _defineProperty(this, "formatValue", () => {
      const _this$props3 = this.props,
            type = _this$props3.type,
            value = _this$props3.value,
            decimals = _this$props3.decimals;

      if (type === "INTEGER") {
        return this.formatInteger();
      }

      if (type === "FLOAT") {
        return this.formatFloat();
      }

      if (type === "PERCENT") {
        return this.formatPercent();
      }

      if (type === "TIME") {
        return this.formatTime();
      }

      if (type === "DURATION") {
        return this.formatDuration();
      }

      return value;
    });

    _defineProperty(this, "formatName", () => {
      const name = this.props.name;

      if (messages[name]) {
        return messages[name];
      }

      return name;
    });
  }

  render() {
    const _this$props4 = this.props,
          name = _this$props4.name,
          type = _this$props4.type,
          value = _this$props4.value;

    if (value) {
      return this.formatValue();
    }

    if (name) {
      return this.formatName();
    }

    return null;
  }

}

_defineProperty(FormatMetric, "contextTypes", {
  intl: PropTypes.object
});

_defineProperty(FormatMetric, "defaultProps", {
  decimals: 2
});

FormatMetric.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.number,
  decimals: PropTypes.number
} : {};
export default FormatMetric;